import { createContext, useContext } from 'react'

export type OpenCallNotes = (callID: string, entryID?: string | null) => void

const CallNotesHandlerContext = createContext<OpenCallNotes | null>(null)

export const CallNotesHandlerProvider = CallNotesHandlerContext.Provider

// Set by a host that shows the header outside Standard's participant routes, where Notes can't navigate to the records page.
export const useCallNotesHandler = (): OpenCallNotes | null => useContext(CallNotesHandlerContext)
